export function findNestedObjectByKey(obj: any, key: string, value: any) {
    if (obj[key] === value) {
        return obj;
      } else {
        var keys = Object.keys(obj); // add this line to iterate over the keys
    
        for (var i = 0, len = keys.length; i < len; i++) {
          var k = keys[i];
    
          // add "obj[k] &&" to ignore null values
          if (obj[k] && typeof obj[k] == 'object') {
            var found = findNestedObjectByKey(obj[k], key, value);
            if (found) {
              // If the object was found in the recursive call, bubble it up.
              return found;
            }
          }
        }
      }
}
